import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

const News = function () {
  return (
    <AbstractCollection
      collectionName="News"
      singleCollectionName="Single News"
      notToShow={[
        'ancestorIds',
        'parentId',
        'images',
        'videos',
        'type',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'coverPhoto', 'status', 'featured', 'createdAt']}
      type={typeConstant.NEWS}
    />
  )
}
export default News
